<template>
	<div class="main">
		<div class="main_body">
			<div class="main_content_banner">
				<el-carousel :interval="1500" type="card" height="350px">
					<el-carousel-item v-for="(item, index) in list_image" :key="index">
						<img :src="item.link_image" height="350" />
					</el-carousel-item>
				</el-carousel>
			</div>
			
			<div class="main_title">
				<div class="main_title_left"></div>集团简介 | Fulright
			</div>
			<div class="main_content">
				<div v-html="this.form.a_content"></div>
				<br/><br/>
				
				<img :src="list_prod.link_image" width="100%">
				
			</div>
			
		</div>
		
		
		
	</div>
</template>

<script>
export default {
	data() {
		return{
			form:{
				article_id: 0,
				a_title: '',
				a_content: ''
			},
			list_image: [],
			list_prod: [],
		}
	},
	mounted() {
		if(this._isMobile()){
			location.href = '#/mobi'
		}
		document.title = '集团简介-北京府右控股集团有限公司';
		this.loadDetail(10044);
		this.loadImageList();
		this.loadDetailImage(10020);
	},
	methods: {
		jump(offsettop){
			// 获取需要滚动的距离
			let total = offsettop;
			var x = 0;
			var tmptime = setInterval(()=>{
				x += 9;
				//window.console.log(x);
				document.body.scrollTop = x; // Chrome
				document.documentElement.scrollTop = x; // Firefox
				window.pageYOffset = x; // Safari
				if(x>=total){
					clearInterval(tmptime);
				}
			},1);
		},
		
		_isMobile() {
			let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
			return flag;
		},
		
		//加载文章详情
		loadDetail(id) {
			this.$axios({
				method: 'get',
				url: this.common.apiUrl + '/Article/Detail/' + id
			}).then((response) => {
				if(response.data.status == 200) {
					//window.console.log(response.data);
					var res = response.data.result;
					if(res.length == 1) {
						//window.console.log(res[0]);
						this.form = res[0];
					}
				}
			}).catch((error) => {
				this.$message({message: '出现异常，联系管理员', type: 'warning', duration: 0});
				window.console.log(error);
			});
		},
		
		//加载幻灯片
		loadImageList() {
			let client_data = {'link_type': '10001'}
			this.$axios({
				method: 'post',
				url: this.common.apiUrl + '/Link/List',
				data: this.qs.stringify(client_data),
			}).then((response) => {
				if(response.data.status == 200) {
					//window.console.log(response.data);
					var res = response.data.result;
					if(res.length > 0) {
						//window.console.log(res);
						this.list_image = res;
					}
				}
			}).catch((error) => {
				this.$message({message: '出现异常，联系管理员', type: 'warning', duration: 0});
				window.console.log(error);
			});
		},
		
		//加载下方产品
		loadDetailImage(id) {
			this.$axios({
				method: 'get',
				url: this.common.apiUrl + '/Link/Detail/' + id,
			}).then((response) => {
				if(response.data.status == 200) {
					//window.console.log(response.data);
					var res = response.data.result;
					if(res.length > 0) {
						window.console.log(res[0]);
						this.list_prod = res[0];
					}
				}
			}).catch((error) => {
				this.$message({message: '出现异常，联系管理员', type: 'warning', duration: 0});
				window.console.log(error);
			});
		},
		
	}
}
</script>

<style>
.con{
	width: auto !important;
}
.el-carousel__item h3 {
color: #475669;
font-size: 14px;
opacity: 0.75;
line-height: 200px;
margin: 0;
}
.el-carousel__item:nth-child(2n) {
background-color: #99a9bf;
}
.el-carousel__item:nth-child(2n+1) {
background-color: #d3dce6;
}
.el-carousel__item--card.is-in-stage{
	cursor:default !important;
}
td{
	border: 0px solid #ddd;
	text-align: center;
	padding-top: 25px;
	padding-bottom: 25px;
	font-size: 16px;
	font-weight: 200;
}
td:hover{
	border-top: 0px solid #aaa;
	border-bottom: 0px solid #aaa;
	font-size: 16px;
	font-weight: 300;
}
.main_title_bottom{
	width: 110px;
	height: 3px;
	background: #661212;
	margin-top: -1px;
	float: left;
	position: absolute;
}
.prod_div{
	width: 140px;
	height: 100px;
	float: left; 
	overflow: hidden; 
	text-align: center; 
	vertical-align: middle;
}
</style>
